import React from 'react';
import { GoogleLogo } from './GoogleLogo';

const kebab = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
const isGoogleReviewMetric = (number, label) => `${number} ${label}`.toLowerCase().includes('google') || `${number} ${label}`.includes('700+');

export const ProofMetric = ({ number, label, testIdPrefix }) => {
  const testSlug = kebab(label);
  const showGoogleLogo = isGoogleReviewMetric(number, label);

  return (
    <div className="proof-metric bg-gray-900 text-white min-w-0 px-4 py-4" data-testid={`${testIdPrefix}-${testSlug}`}>
      <p className="text-2xl font-extrabold leading-none flex items-center gap-2" data-testid={`${testIdPrefix}-${testSlug}-number`}>
        {showGoogleLogo && <GoogleLogo className="h-5 w-5 flex-shrink-0" testId={`${testIdPrefix}-${testSlug}-google-logo`} />}
        <span className="break-words" data-testid={`${testIdPrefix}-${testSlug}-value`}>{number}</span>
      </p>
      <p className="text-xs text-gray-400 mt-1" data-testid={`${testIdPrefix}-${testSlug}-label`}>{label}</p>
    </div>
  );
};